import React, { useState } from 'react'
import {Helmet} from "react-helmet";
import {MdOutlineContentCopy} from 'react-icons/md'; 
import {IoMdCheckmarkCircleOutline} from 'react-icons/io'
import { Header, ComponentDisplay } from '../components'
import './styles.css';
import {Button} from 'aurorui';
import { useNavigate } from 'react-router-dom';

function HomeScreen() {
  const [isCopied, setIsCopied] = useState(false);
  let navigate = useNavigate();

  async function copyTextToClipboard(text) {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand('copy', true, text);
    }
  }

  const handleCopyClick = () => {
    // Asynchronously call copyTextToClipboard
    copyTextToClipboard('npm i aurorui')
      .then(() => {
        // If successful, update the isCopied state value
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1500);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  return (
    <div className='home-screen'>


        <Helmet>
            <meta charSet="utf-8" />
            <title>AURORUI</title>
        </Helmet>

        <Header />
        
        <div className='sec-1'>
            <h1 className='sec-1-head'>AUROR UI</h1>
            <p className='sec-1-desc'>
                A light weight type safe component library fro react apps.<br />
                The libraray included component like buttons, drawer, modals, toasts.
            </p>
            <div className='copy-npm'>
                <p>npm i aurorui</p>
                {!isCopied ? <div onClick={handleCopyClick} style={{
                  cursor: 'pointer'
                }}><MdOutlineContentCopy /></div> : <IoMdCheckmarkCircleOutline /> }
            </div>
            <div>
              <Button 
                label="Discover Components"
                variant='filled'
                type='secondary'
                size='large'
                roundedType={'extralarge'}
                onClick={()=>{
                  navigate('/input')
                }}
                disabled={false}
              />
            </div>
        </div>
    </div>
  )
}

export default HomeScreen